export default __webpack_public_path__ + "static/media/check-white.14b1948a.svg";